<template>
    <v-card v-redirect-if-no-permission:VOUCHERS>
        <loading-component :value="loadingPage"/>
        <loading-component :value="loading"/>
        <v-card-title primary-title class="font-weight-bold title">Voucher Editor</v-card-title>
        <v-divider/>
        <v-card-text v-if="!loadingPage">
            <v-form ref="form">
                <v-layout row wrap>
                    <v-flex xs12 md5>
                        <v-text-field label="Code" v-model="code" :disabled="generating_random || !!$route.params.id"
                                      prepend-icon="vpn_key" :loading="generating_random" append-icon="sync"
                                      @click:append="generateCode" :error-messages="errors.code"/>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-text-field v-model="title" :disabled="!!$route.params.id" label="Title" prepend-icon="title"
                                      :error-messages="errors.title"/>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-text-field v-model="details" label="Details" prepend-icon="message"
                                      :disabled="!!$route.params.id" :error-messages="errors.details"/>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-text-field v-model="use_times" :disabled="!!$route.params.id"
                                      :error-messages="errors.use_times" type="number" label="Usage Times"
                                      prepend-icon="check"/>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-radio-group v-model="type" :disabled="!!$route.params.id" row>
                            <template slot="label">
                                <div>Voucher <strong> Discount Type:</strong></div>
                            </template>
                            <v-radio off-icon="close" on-icon="check" value="PERCENTAGE"
                                     :class="{clicked: type === 'PERCENTAGE'}" label="Percentage"/>
                            <v-radio off-icon="close" on-icon="check" value="CASH" :class="{clicked: type === 'CASH'}"
                                     label="Cash"/>
                            <v-radio off-icon="close" on-icon="check" value="FIXED" :class="{clicked: type === 'FIXED'}"
                                     label="Fixed"/>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-text-field v-model="amount" :disabled="!!$route.params.id" :error-messages="errors.amount"
                                      prepend-icon="money" type="number" min="1">
                            <div slot="label">Amount
                                <template v-if="type === 'PERCENTAGE'">(%)</template>
                            </div>
                            <template slot="append">
                                <template v-if="type === 'PERCENTAGE'">%</template>
                                <template v-else>SYP</template>
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width max-width="290px" min-width="290px">
                            <template slot="activator">
                                <v-text-field label="From Date" persistent-hint :value="start_date"
                                              prepend-icon="event" :error-messages="errors.start_date"/>
                            </template>
                            <v-date-picker v-model="start_date" no-title :min="(moment().format('YYYY-MM-DD'))"/>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width max-width="290px" min-width="290px">
                            <template slot="activator">
                                <v-text-field label="To Date" persistent-hint :error-messages="errors.end_date"
                                              :value="end_date" prepend-icon="event"/>
                            </template>
                            <v-date-picker v-model="end_date" no-title
                                           :min="(start_date ? start_date : moment().format('YYYY-MM-DD'))"/>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-select v-model="slice" prepend-icon="list" :items="slices" :disabled="!!$route.params.id"
                                  label="Slice"/>
                    </v-flex>
                    <v-flex xs12 md5 offset-md2>
                        <v-select :disabled="!!$route.params.id" v-model="time_slice"
                                  prepend-icon="settings_backup_restore" :items="time_options" label="Time Slice"/>
                    </v-flex>
                    <v-flex xs12>
                        <v-switch :disabled="!!$route.params.id" v-model="show_customers_limit"
                                  label="First Customers"/>
                    </v-flex>
                    <v-flex xs12 v-if="show_customers_limit">
                        <v-text-field :disabled="!!$route.params.id" v-model="customers_limit"
                                      :error-messages="errors.customers_limit" type="number"
                                      label="Only First (N) Customers Can Get It" prepend-icon="fa fa-university"/>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-switch v-model="show_times" label="Custom Times"/>
                    </v-flex>
                    <template v-if="show_times">
                        <v-flex xs12 md5>
                            <v-menu :nudge-right="40" :close-on-content-click="false" lazy transition="scale-transition"
                                    offset-y full-width max-width="290px" min-width="290px">
                                <template slot="activator">
                                    <v-text-field label="From Time" persistent-hint
                                                  :value="start_time" :error-messages="errors.start_time"
                                                  prepend-icon="fa fa-hourglass"/>
                                </template>
                                <v-time-picker format="24hr" v-model="start_time"/>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md5 offset-md2 :class="{times_section: true,active: show_times}">
                            <v-menu :nudge-right="40" :close-on-content-click="false" lazy transition="scale-transition"
                                    offset-y full-width max-width="290px" min-width="290px">
                                <template slot="activator">
                                    <v-text-field label="To time" persistent-hint
                                                  :value="end_time" :error-messaged="errors.end_time"
                                                  prepend-icon="fa fa-hourglass"/>
                                </template>
                                <v-time-picker format="24hr" v-model="end_time" :min="start_time"/>
                            </v-menu>
                        </v-flex>
                    </template>
                    <v-flex xs12 md12>
                        <v-switch :disabled="!!$route.params.id" v-model="show_passengers" label="Custom Passengers"/>
                    </v-flex>
                    <v-flex xs12 md6 v-if="show_passengers">
                        <v-radio-group v-model="csv_file" row>
                            <template slot="label">
                                <div>Selection <strong> Type:</strong></div>
                            </template>
                            <v-radio off-icon="close" on-icon="check" :value="true" :class="{clicked: csv_file}"
                                     label="CSV File"/>
                            <v-radio off-icon="close" on-icon="check" :value="false" :class="{clicked: !csv_file}"
                                     label="Normal Select"/>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12 md6 v-if="show_passengers">
                        <choose-passenger-multi v-if="!csv_file" :rules="[v => !!v || 'This Field Is Required']"
                                                return-object v-model="passengers" label="Choose Passengers"/>
                        <template v-else>
                            <v-label>CSV File(each line is an id of a passenger)</v-label>
                            <input type="file" accept=".csv,.txt" @change="passengersCSVChanges"/></template>
                    </v-flex>
                    <v-flex :disabled="!!$route.params.id" xs12 md12>
                        <v-switch :disabled="!!$route.params.id" v-model="show_services" label="Custom Services"/>
                    </v-flex>
                    <v-flex xs12 md12 v-if="show_services">
                        <choose-service-multi :rules="[v => !!v || 'This Field Is Required']" return-object
                                              v-model="services" label="Choose Services"/>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-switch :disabled="!!$route.params.id" v-model="show_include_locations"
                                  label="Custom Whitelist Areas"/>
                    </v-flex>
                    <v-flex xs12 md12 v-if="show_include_locations">
                        <choose-location-multi :rules="[v => !!v || 'This Field Is Required']" return-object
                                               v-model="include_areas" label="Choose Areas"/>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-switch :disabled="!!$route.params.id" v-model="show_exclude_locations"
                                  label="Custom Blacklist Areas"/>
                    </v-flex>
                    <v-flex xs12 md12 v-if="show_exclude_locations">
                        <choose-location-multi :rules="[v => !!v || 'This Field Is Required']" return-object
                                               v-model="exclude_areas" label="Choose Areas"/>
                    </v-flex>

                    <v-flex offset-xs9 xs3>
                        <v-btn color="primary" @click="save">
                            Save
                        </v-btn>
                    </v-flex>
                    <template v-if="$route.params.id && passengers.length > 0">
                        <v-flex offset-xs9 xs3>
                            <v-btn color="primary" @click="exportPassengers">Export Passengers As Csv</v-btn>
                        </v-flex>
                    </template>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
    import ChooseServiceMulti from "@/components/wasilni/input/ChooseServiceMulti";
    import ChooseLocationMulti from "@/components/wasilni/input/ChooseLocationMulti";
    import {saveAs} from 'file-saver';
    import LoadingComponent from "@/components/LoadingComponent";
    import stringify from "csv-stringify";

    export default {
        title: 'Edit Voucher',
        components: {LoadingComponent, ChoosePassengerMulti, ChooseServiceMulti, ChooseLocationMulti},
        data() {
            return {
                generating_random: false,
                loading: false,
                loadingPage: false,
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null,
                code: null,
                csv_file: false,
                time_options: ['SCHEDULED', 'NOW', 'BOTH'],
                time_slice: 'BOTH',
                slices: ['DAILY', 'WEEKLY', 'MONTHLY', 'EVER'],
                slice: 'EVER',
                show_include_locations: false,
                show_exclude_locations: false,
                show_services: false,
                show_times: false,
                show_passengers: false,
                type: 'PERCENTAGE',
                title: null,
                details: null,
                passengers: [],
                use_times: null,
                services: [],
                include_areas: [],
                exclude_areas: [],
                amount: null,
                customers_limit: null,
                show_customers_limit: false,
                errors: {}
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loadingPage = true;
                this.axios.get(this.api.ACTIONS.VOUCHERS + '/' + this.$route.params.id)
                    .then(({data: {data: {amount, code, customers_limit, details, end_date, type, is_public, end_time, blacklist_locations, whitelist_locations, passengers, services, slice, specific_location_whitelist, specific_location_blacklist, specific_service, start_date, start_time, time_slice, title, use_times}}}) => Object.assign(this.$data, {
                        amount,
                        code,
                        customers_limit,
                        details,
                        end_time: !!end_time ? moment(end_time).format("HH:mm") : null,
                        end_date: moment(end_date).format("YYYY-MM-DD"),
                        show_times: !!end_time || !!start_time,
                        type,
                        include_areas: whitelist_locations,
                        exclude_areas: blacklist_locations,
                        passengers,
                        services,
                        slice,
                        show_passengers: !is_public,
                        show_include_locations: !!specific_location_whitelist,
                        show_exclude_locations: !!specific_location_blacklist,
                        show_services: !!specific_service,
                        show_customers_limit: !!customers_limit,
                        start_date: moment(start_date).format("YYYY-MM-DD"),
                        start_time: !!start_time ? moment(start_time).format("HH:mm") : null,
                        time_slice,
                        title,
                        use_times
                    })).catch(() => this.$router.push({name: "NotFound"})).finally(() => this.loadingPage = false);
            }
        },
        computed: {
            pureAttributes() {
                const {
                    start_date, end_date, start_time, end_time, code, time_slice,
                    slice, type, title, details, passengers, use_times, services, include_areas, exclude_areas, amount, show_include_locations, show_exclude_locations, show_services, show_times, show_passengers, show_customers_limit, customers_limit
                } = this.$data;
                let data = {start_date, end_date, code, time_slice, slice, type, title, details, use_times, amount};
                if (show_times) Object.assign(data, {start_time, end_time});
                if (show_customers_limit) Object.assign(data, {customers_limit});
                // if (!!this.$route.params.id) data = {};
                if (show_include_locations) Object.assign(data, {include_areas: include_areas.map(area => area.id)});
                if (show_exclude_locations) Object.assign(data, {exclude_areas: exclude_areas.map(area => area.id)});
                if (show_services) Object.assign(data, {services: services.map(service => service.id)});
                if (show_passengers) Object.assign(data, {passengers: passengers.map(passenger => passenger.id)});
                return data;
            }
        },
        methods: {
            passengersCSVChanges(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    if (files[0].name.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsText(files[0]);
                    fr.addEventListener('load', () => {
                        this.passengers = fr.result.split("\n").filter(item => !isNaN(parseInt(item)) && parseInt(item) == item).map(item => ({
                            id: item,
                            first_name: "Passenger of id " + item,
                            last_name: ""
                        }));
                    })
                }
            }, exportPassengers() {
                this.loading = true;
                let passengers = this.passengers.map(({id}) => id);
                passengers = ['id', ...passengers].map(element => [element]);
                const fileName = `passengers-voucher-${this.code}.csv`;
                stringify(passengers, async (_, output) => {
                    const blob = new Blob([output], {type: "text/plain;charset=utf-8"});
                    saveAs(blob, fileName);
                    this.loading = false;
                });
            }, generateCode() {
                this.generating_random = true;
                this.axios.get(this.api.ACTIONS.RANDOM_VOUCHER).then(({data}) => {
                    this.code = data.data;
                    this.generating_random = false;
                })
            }, save() {
                const id = this.$route.params.id;
                const axios = !!this.$route.params.id ? this.axios.put : this.axios.post;
                if (!!id) {
                    if (this.show_include_locations && (!this.include_areas || this.include_areas.length === 0)) {
                        window.getApp.$emit("SHOW_TOAST", "You have to select locations!", "red");
                        return;
                    } else if (this.show_exclude_locations && (!this.exclude_areas || this.exclude_areas.length === 0)) {
                        window.getApp.$emit("SHOW_TOAST", "You have to select locations!", "red");
                        return;
                    } else if (this.show_passengers && (!this.passengers || this.passengers.length === 0)) {
                        window.getApp.$emit("SHOW_TOAST", "You have to select passengers!", "red");
                        return;
                    } else if (this.show_services && (!this.services || this.services.length === 0)) {
                        window.getApp.$emit("SHOW_TOAST", "You have to select services!", "red");
                        return;
                    }
                }
                this.loading = true;
                axios(this.api.ACTIONS.VOUCHERS + (id ? `/${id}` : ''), this.pureAttributes).then(({data: {data}}) => {
                    window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                    if (!id) this.$router.push({name: 'VoucherDetails', params: {id: data.id}});
                }).catch(({response}) => {
                    if (response.status === 422) {
                        const {data: body} = response;
                        const {errors} = body;
                        this.errors = errors;
                    } else {
                        window.getApp.$emit("SHOW_TOAST", "Error Happened (Check console log)", "red");
                        console.log(response.data);
                    }
                }).finally(() => this.loading = false)
            }
        },
        name: "VouchersEditor"
    }
</script>

<style scoped lang="scss"> .clicked {
    background: #00FF0044;
    border-radius: 10px;
}</style>